import { InjectionToken } from '@angular/core';

export interface EnvironmentKeycloakConfig {
  issuer: string;
  realm: string;
  clientId: string;
}

export const APP_ENVIRONMENT_KEYCLOAK = new InjectionToken<EnvironmentKeycloakConfig>(
  'Environment variable for keycloak'
);
